import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedVideos from './components/FeaturedVideos';
import HotVideos from './components/HotVideos';
import NewsSection from './components/NewsSection';
import FaqSection from './components/FaqSection';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '宅男视频',
  url: 'https://zhainanvideo.com',
  description: '宅男视频接入久久视频、小蓝视频、豆花视频等稳定平台，提供不缓冲的流畅高清观看体验，免费影视全集每日更新，久用不卡顿更顺畅。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://zhainanvideo.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '宅男视频',
  url: 'https://zhainanvideo.com',
  description: '宅男视频 - 久久视频小蓝视频流畅高清在线观看不缓冲体验，豆花视频免费影视全集',
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />

      <Navbar />

      <main>
        <article>
          <HeroSection />
          <CategoryNav />
          <FeaturedVideos />
          <HotVideos />
          <NewsSection />
          <FaqSection />
        </article>
      </main>

      <Footer />
    </>
  );
}